export function isDevMode() {
  return !process.env.NODE_ENV || process.env.NODE_ENV === "development";
}

export function fileToByteArray(file: File): Promise<any[]> {
  var reader = new FileReader();
  var fileByteArray: any[] = [];
  reader.readAsArrayBuffer(file);

  return new Promise(function (resolve, reject) {
    reader.onloadend = function (evt) {
      if (evt.target?.readyState === FileReader.DONE) {
        var arrayBuffer = evt.target.result,
          array = new Uint8Array(arrayBuffer as ArrayBuffer);
        for (var i = 0; i < array.length; i++) {
          fileByteArray.push(array[i]);
        }
        resolve(fileByteArray);
      }
    };
  });
}

export function fileToBase64(file): Promise<string> {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  return new Promise(function (resolve, reject) {
    reader.onload = function () {
      resolve(reader.result as string);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
}
